//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import bus from "../../common/bus";
import Tools from "../../common/Tools";
import api from "../../../api/api.js";
import apiAllSystem from "../../../api/apiAllSystem.js";
export default {
  name: 'taskCreate',
  components: {},
  data: function data() {
    return {
      labelPosition: "top",
      pagesize: 10,
      //每页显示条数
      curPage: 1,
      //当前页数         
      multipleSelection: [],
      ruleForm: {
        company: "",
        group: ""
      },
      companySelect: [],
      groupSelect: [],
      modeSelect: [],
      seriesSelect: [],
      tableData: [],
      loading: false,
      autoMatch: true
    };
  },
  computed: {
    rules: function rules() {
      return {
        company: [{
          required: true,
          message: this.$t('Rules.require'),
          trigger: 'blur'
        }],
        group: [{
          required: true,
          message: this.$t('Rules.require'),
          trigger: 'blur'
        }, {
          type: "string",
          pattern: /^[\u4E00-\u9FA5a-zA-Z0-9]+([_-][\u4E00-\u9FA5a-zA-Z0-9]+)*$/,
          min: 2,
          max: 20,
          message: this.$t('Rules.name'),
          trigger: 'blur'
        }]
      };
    }
  },
  created: function created() {
    this.getCompany();
  },
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getCompany: function getCompany() {
      var _this = this;

      var params = {
        usersssid: localStorage.getItem('sssid')
      };
      api.getUser(params).then(function (res) {
        if (res.state) {
          _this.companySelect = res.value;
        } else {
          _this.$message.error(res.value.text);
        }
      }).catch(function (error) {
        _this.$message.error(_this.$t('Message.reqError'));
      });
    },
    onSubmit: function onSubmit(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var param = {
            usersssid: _this2.ruleForm.company
          };
          var bodyParams = {
            // sssid: this.ruleForm.company,
            trackergroupname: _this2.ruleForm.group
          };
          api.creatTrackerGroup(param, bodyParams).then(function (res) {
            if (res.state) {
              _this2.$message.success(_this2.$t('Message.success'));

              _this2.$router.push({
                path: '/groupManage',
                query: {
                  detail: res.value.text
                }
              });
            } else {
              _this2.$message.error(res.value.text);
            }
          }).catch(function (error) {
            _this2.$message.error(_this2.$t('Message.reqError'));
          });
        }
      });
    }
  }
};